
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","viewBox":"0 0 14 16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.2362 3.42188H2.57422C0.149611 3.42188 0.128057 0.421875 2.54706 0.421875H11.209C13.6338 0.421875 13.6552 3.42188 11.2362 3.42188Z"}}),_c('path',{attrs:{"d":"M11.2362 9.42188H2.57422C0.149611 9.42188 0.128057 6.42188 2.54706 6.42188H11.209C13.6338 6.42188 13.6552 9.42188 11.2362 9.42188Z"}}),_c('path',{attrs:{"d":"M11.2362 15.4219H2.57422C0.149611 15.4219 0.128057 12.4219 2.54706 12.4219H11.209C13.6338 12.4219 13.6552 15.4219 11.2362 15.4219Z"}})])
          )
        }
      }
    